import { Worker } from './api/payment/type';

export interface Paginated<T> {
  items: T[];
  pagination: {
    totalItemCount: number;
    currentItemCount: number;
    totalPage: number;
    currentPage: number;
    itemsPerPage: number;
  };
}

export interface FilterType {
  [key: string]: string | number[];
}

export interface PaginationDto {
  sort?: string;
  filter?: FilterType | string;
  page?: number;
  itemsPerPage?: number;
}

export interface User {
  id: number;
  createdAt: string;
  updatedAt: string;
  email: string;
  role: Role;
  name: string;
  /** @deprecated adminRole로 대체됨. 권한 판정은 hasAdminRole()을 쓸 것 */
  isOperator: boolean;
  adminRole?: AdminRole;
  worker?: Worker;
  pointRewardRate?: number;
}

export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

/**
 * 어드민 계정 등급 — 낮은 쪽이 좁다. REVIEWER ⊂ STAFF ⊂ OPERATOR.
 *
 * Role.ADMIN 안에서 다시 나누는 축이다. 서버는 Role.ADMIN까지만 보므로
 * 이 등급은 어드민 화면의 메뉴·라우트·탭 노출만 결정한다.
 */
export enum AdminRole {
  /** 심사·시연용. 회원/업장관리자/회사/알바신청자/공지/배너만 */
  REVIEWER = 'REVIEWER',
  /** 일반 어드민. 급여 정산 제외 전부 */
  STAFF = 'STAFF',
  /** 운영자. 전부 */
  OPERATOR = 'OPERATOR',
}

export enum WorkDateType {
  ALL = 'ALL',
  WEEKDAY = 'WEEKDAY',
  WEEKEND = 'WEEKEND',
}

export enum WorkTimeType {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  FULLTIME = 'FULLTIME',
}
